import { getAppInformationLinks } from "../config/appInformation";
import "../styles/app-information.css";

export default function AppInformationLinks({ className = "" }) {
  const links = getAppInformationLinks();
  if (!links.length) return null;
  return (
    <nav aria-label="App information" className={["app-information-links", className].filter(Boolean).join(" ")}>
      {links.map(({ id, label, href }) => (
        <a href={href} key={id} rel="noopener noreferrer" target="_blank">{label}</a>
      ))}
    </nav>
  );
}
